<template>
  <div class="status-indicator" :class="{ 'listening': isListening }">
    <i class="fas fa-microphone"></i>
    <span>{{ isListening ? 'Listening...' : 'Processing...' }}</span>
  </div>
</template>

<script>
export default {
  name: "BSPStatusIndicator",
  props: {
    isListening: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.status-indicator {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: $slate10;
  border-radius: 20px;
  font-size: 0.9rem;
  color: $slate60;

  i {
    margin-right: 0.5rem;
    color: $slate60;
  }

  &.listening {
    background-color: $orange10;
    color: $orange;

    i {
      color: $orange;
    }
  }
}
</style>
